import { pgTable, text, timestamp, unique } from "drizzle-orm/pg-core";
import { tenant } from "../auth";

/**
 * Thin per-tenant box projection, no longer written or read. `GET /catalog/in-box`
 * answers which boxes contain an item from `drop_table_items` instead. The table
 * is dropped by the contract migration.
 */
export const tenantBoxes = pgTable(
  "tenant_boxes",
  {
    id: text("id").primaryKey(), // ulid
    /** NULL = box template, shared across every tenant. */
    tenantId: text("tenant_id").references(() => tenant.id, { onDelete: "cascade" }),
    boxId: text("box_id").notNull(),
    /** available | unavailable | archived */
    status: text("status").notNull(),
    catalogIds: text("catalog_ids").array().notNull().default([]),
    listingIds: text("listing_ids").array().notNull().default([]),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  // A unique constraint, not an index: drizzle only offers nullsNotDistinct here.
  (t) => [unique("tenant_boxes_tenant_box_key").on(t.tenantId, t.boxId).nullsNotDistinct()],
);
